import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from "vue"
import { usePageStore } from "@/store"
import {storeToRefs} from "pinia";
import {CellGroup as VanCellGroup, Cell as VanCell, Toast} from "vant"

import "vant/es/cell-group/style"
import "vant/es/cell/style"


export default /*#__PURE__*/_defineComponent({
  __name: 'ResultPage',
  setup(__props) {


const pageStore = usePageStore()
const pageStroeRef = storeToRefs(pageStore)

const isWin = ref<boolean>(false)

onMounted(() => {
  pageStore.submitResult().then((result) => {
    isWin.value = result
    if (isWin.value) {
      setTimeout(() => {
        location.href = `https://app-act.ngzb.com.cn/activity/Award/index?activityId=${pageStore.$state.pageInfo.collect?.connection_id}`
      }, 2500)
    }

  })
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "wrap",
    style: _normalizeStyle({
  backgroundImage: `url(${_unref(pageStore).pageInfo.collect?.bg_image})`
})
  }, [
    _createVNode(_unref(VanCellGroup), {
      inset: "",
      class: "winWrap"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("h3", null, "恭喜您全部答对" + _toDisplayString(" "+_unref(pageStore).pageInfo.collect?.connection_id ? "稍等片刻马上抽奖" : ""), 513), [
          [_vShow, isWin.value]
        ]),
        _withDirectives(_createElementVNode("h3", null, "很遗憾，您没有全部答对", 512), [
          [_vShow, !isWin.value]
        ])
      ]),
      _: 1
    })
  ], 4))
}
}

})